import { handleActions } from 'redux-actions';
import paths from '../../../routes/paths';
import { ROUTE } from '../../middleware/route';
import { isValidAddressLine, maxLengthValid, notEmptyString, validate } from '../../middleware/validator';
import { addressLineMaxLen } from '../../../../config/utils';

export const SET_ADDRESS = 'SIGNUP/SET_ADDRESS';

const postcodePattern = new RegExp(
  '(^([Gg][Ii][Rr] ?0[Aa]{2})$)|(^((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2})$)',
);

/**
 * Handles leading/trailing whitespace & one block of white space of any length
 * eg. '   M1    5ST    '
 * Trimming and removal of whitespace should be taken care of before posting data to API
 * Once trimmed replace will reduce any internal whitespace to a single space
 */
export const formatPostcode = postcode => {
  if (!postcode) {
    return postcode;
  }
  return postcode.trim().replace(/[ ]{2,}/, ' ');
};

export const isPostcodeValid = postcode => notEmptyString(postcode)
  && postcodePattern.test(formatPostcode(postcode));

export const setAddress = (line1, line2, townCity, postcode) => ({
  [validate]: {
    validator: () => isPostcodeValid(postcode) && isValidAddressLine(townCity) && isValidAddressLine(line1) && (!notEmptyString(line2) || isValidAddressLine(line2)) && maxLengthValid(line1, addressLineMaxLen) && maxLengthValid(line2, addressLineMaxLen) && maxLengthValid(townCity, addressLineMaxLen),
    success: { type: SET_ADDRESS,
      line1,
      line2,
      townCity,
      postcode,
      [ROUTE]: paths.signup.gpDetails,
    },
    fail: { type: SET_ADDRESS, line1, line2, townCity, postcode },
  },
});

export const getAddress = state => state.address || {};
export const getAddressErrors = state => state.addressErrors || {};
export const getAddressLine1 = state => getAddress(state).line1;
export const getAddressLine1Error = state => getAddressErrors(state).line1;
export const getAddressLine2Error = state => getAddressErrors(state).line2;
export const getAddressLine2 = state => getAddress(state).line2;
export const getTownCity = state => getAddress(state).townCity;
export const getTownCityError = state => getAddressErrors(state).townCity;
export const getPostcode = state => getAddress(state).postcode;
export const getPostcodeError = state => getAddressErrors(state).postcode;

export const address = handleActions({
  [SET_ADDRESS]: (state, action) => ({
    line1: action.line1,
    line2: action.line2,
    townCity: action.townCity,
    postcode: action.postcode,
  }),
}, null);

export const addressErrors = handleActions({
  [SET_ADDRESS]: (state, action) => ({
    line1: isValidAddressLine(action.line1) ? (maxLengthValid(action.line1, addressLineMaxLen) ? null : 'Character limit exceeded. Please continue address on line 2.'): 'Address cannot contain special characters',
    line2: (!notEmptyString(action.line2) || isValidAddressLine(action.line2)) ? (maxLengthValid(action.line2, addressLineMaxLen) ? null : 'Character limit exceeded'): 'Address cannot contain special characters',
    townCity: isValidAddressLine(action.townCity) ? (maxLengthValid(action.townCity, addressLineMaxLen) ? null : 'Character limit exceeded') : 'Address cannot contain special characters',
    postcode: isPostcodeValid(action.postcode) ? null : 'Postcode is invalid',
  }) }, null);
